import { OrderingInitialState } from '@reducers/ordering/types';

export const removeCoupon = (state: OrderingInitialState): OrderingInitialState => ({
  ...state,
  couponState: {
    ...state.couponState,
    couponCode: undefined,
    coupon: undefined,
  },
});
